module.exports = __webpack_public_path__ + "static/media/buzka-zielona.1e566248.svg";